<template>
  <div class="card">
    <div
      class="card-body py-3 d-flex justify-content-between align-items-center"
    >
      <h2 class="h5 mb-0 titulo_pagina">Usuarios</h2>

      <button
        class="btn btn-success d-inline-flex align-items-center gap-1"
        @click="onAdd"
      >
        <span class="material-symbols-rounded">add</span>
        Agregar
      </button>
    </div>

    <div class="card-body pt-0">
      <div v-if="loading" class="text-center py-5">
        <Loading mensaje="Cargando usuarios…" />
      </div>

      <div
        v-else-if="usuarios.length === 0"
        class="alert alert-info mb-0"
        role="alert"
      >
        <SinDatos mensaje="No hay usuarios cargados por el momento." />
      </div>

      <div v-else class="table-responsive fo-table-wrap">
        <table class="table table-sm table-hover align-middle mb-0 fo-table">
          <thead>
            <tr>
              <th>Usuario</th>
              <th>Nombre</th>
              <th>Apellido</th>
              <th>Email</th>
              <th>Celular</th>
              <th>Rol</th>
              <th>Último Login</th>
              <th class="fo-col-actions">Acciones</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="u in usuarios"
              :key="u.id_usuario"
              :class="{
                registro_baja: u.baja_fecha && u.baja_fecha !== 'null',
              }"
            >
              <td>{{ u.usuario }}</td>
              <td>{{ u.nombre }}</td>
              <td>{{ u.apellido }}</td>
              <td>{{ u.email }}</td>
              <td>{{ u.celular }}</td>
              <td>{{ u.rol_descripcion }}</td>
              <td>{{ u.ultimo_login }}</td>

              <td>
                <div class="fo-actions">
                  <button
                    class="btn btn-outline-primary"
                    @click="onEdit(u)"
                    v-if="!u.baja_fecha || u.baja_fecha === 'null'"
                  >
                    <span class="material-symbols-rounded">edit</span> Editar
                  </button>

                  <button
                    class="btn btn-outline-danger"
                    @click="onDelete(u)"
                    v-if="!u.baja_fecha || u.baja_fecha === 'null'"
                  >
                    <span class="material-symbols-rounded">delete_forever</span>
                    Eliminar
                  </button>

                  <button
                    class="btn btn-outline-primary"
                    @click="onRestore(u)"
                    v-if="u.baja_fecha && u.baja_fecha !== 'null'"
                  >
                    <span class="material-symbols-rounded"
                      >restore_from_trash</span
                    >
                    Recuperar usuario
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- MODAL ALTA / EDICIÓN -->
    <BaseModal
      v-model="modalOpen"
      :title="form.id_usuario ? 'Editar usuario' : 'Agregar usuario'"
      panelClass="w-100 w-md-50"
      :closable="!saving"
      :loading="saving"
      okLabel="Guardar"
      cancelLabel="Cancelar"
      @confirm="onSave"
      @cancel="onCancel"
    >
      <form class="d-flex flex-column gap-3" @submit.prevent="onSave">
        <div class="row g-2">
          <div class="col-12">
            <label class="form-label mb-1">Usuario *</label>
            <input
              class="form-control"
              v-model.trim="form.usuario"
              :disabled="form.id_usuario || saving"
              autocomplete="off"
              placeholder="Ej: jperez"
            />
            <div v-if="errors.usuario" class="text-danger small mt-1">
              {{ errors.usuario }}
            </div>
          </div>

          <div v-if="!form.id_usuario" class="col-12">
            <label class="form-label mb-1">Contraseña *</label>
            <input
              class="form-control"
              type="password"
              v-model.trim="form.password"
              :disabled="saving"
              autocomplete="off"
              placeholder="********"
            />
            <div v-if="errors.password" class="text-danger small mt-1">
              {{ errors.password }}
            </div>
          </div>

          <div v-if="!form.id_usuario" class="col-12">
            <label class="form-label mb-1">Repetir Contraseña *</label>
            <input
              class="form-control"
              type="password"
              v-model.trim="form.password_repeat"
              :disabled="saving"
              autocomplete="off"
              placeholder="********"
            />
            <div v-if="errors.password_repeat" class="text-danger small mt-1">
              {{ errors.password_repeat }}
            </div>
          </div>

          <div class="col-12">
            <label class="form-label mb-1">Nombre *</label>
            <input
              class="form-control"
              v-model.trim="form.nombre"
              :disabled="saving"
              autocomplete="off"
              placeholder="Ej: Gabriel"
            />
            <div v-if="errors.nombre" class="text-danger small mt-1">
              {{ errors.nombre }}
            </div>
          </div>

          <div class="col-12">
            <label class="form-label mb-1">Apellido *</label>
            <input
              class="form-control"
              v-model.trim="form.apellido"
              :disabled="saving"
              autocomplete="off"
              placeholder="Ej: Pérez"
            />
            <div v-if="errors.apellido" class="text-danger small mt-1">
              {{ errors.apellido }}
            </div>
          </div>

          <div class="col-12">
            <label class="form-label mb-1">Email</label>
            <input
              type="email"
              class="form-control"
              v-model.trim="form.email"
              :disabled="saving"
              autocomplete="off"
              placeholder="Ej: gabi@mail.com"
            />
            <div v-if="errors.email" class="text-danger small mt-1">
              {{ errors.email }}
            </div>
          </div>

          <div class="col-12">
            <label class="form-label mb-1">Celular</label>
            <input
              class="form-control"
              v-model.trim="form.celular"
              :disabled="saving"
              autocomplete="off"
              placeholder="Ej: 1134567890"
            />
          </div>

          <div class="col-12">
            <label class="form-label mb-1">Rol *</label>
            <select
              class="form-select form-select-sm"
              v-model.number="form.id_rol"
              :disabled="saving"
            >
              <option v-for="r in roles" :key="r.id_rol" :value="r.id_rol">
                {{ r.descripcion }}
              </option>
            </select>
            <div v-if="errors.id_rol" class="text-danger small mt-1">
              {{ errors.id_rol }}
            </div>
          </div>
        </div>

        <div v-if="saveError" class="alert alert-danger mb-0" role="alert">
          {{ saveError }}
        </div>
      </form>
    </BaseModal>
  </div>

  <!-- MENSAJES -->
  <MostrarMensaje
    v-model:modelValue="mostrarMensajeError"
    status="error"
    :message="mensajeError"
    :duration="duracionMensajeError"
    :closable="true"
  />

  <MostrarMensaje
    v-model:modelValue="mostrarMensajeSuccess"
    status="success"
    :message="mensajeSuccess"
    :duration="duracionMensajeSuccess"
    :closable="true"
  />

  <MostrarMensaje
    v-model:modelValue="mostrarMensajeConfirmacion"
    status="info"
    mode="confirm"
    :duration="0"
    :closable="true"
    ok-label="Confirmar"
    cancel-label="Cancelar"
    :message="mensajeConfirmacion"
    @confirm="borrarUsuario"
    @cancel="onCancel"
  />
</template>

<script setup>
import { ref, reactive, onMounted, ErrorCodes } from "vue";
import Loading from "@/components/Loading.vue";
import SinDatos from "@/components/SinDatos.vue";
import BaseModal from "@/components/BaseModal.vue";
import MostrarMensaje from "@/components/MostrarMensaje.vue";
import { formatFecha } from "@/utils/fecha";
import { minLength } from "@/utils/strings";

// ✅ Ajustá estos imports a tus endpoints reales
import {
  apiGetUsuarios,
  apiPostUsuario,
  apiPutUsuario,
  apiDeleteUsuario,
  apiGetRoles,
  apiPutRecuperarUsuario,
} from "@/api.js";

const loading = ref(true);
const usuarios = ref([]);
const roles = ref([]);

let controller = null;

const modalOpen = ref(false);
const saving = ref(false);
const saveError = ref("");

const form = reactive(resetForm());
const errors = reactive({
  usuario: "",
  password: "",
  password_repeat: "",
  nombre: "",
  apellido: "",
  email: "",
  id_rol: "",
});

const mostrarMensajeError = ref(false);
const mensajeError = ref("");
const duracionMensajeError = ref(5000);

const mostrarMensajeSuccess = ref(false);
const mensajeSuccess = ref("");
const duracionMensajeSuccess = ref(5000);

const esDelete = ref(true);
const mostrarMensajeConfirmacion = ref(false);
const mensajeConfirmacion = ref("");
const idUsuarioDelete = ref(-1);

onMounted(async () => {
  await fetchRoles();
  await fetchUsuarios();
});

function resetForm() {
  return {
    id_usuario: null,
    usuario: "",
    password: "",
    password_repeat: "",
    nombre: "",
    apellido: "",
    email: "",
    celular: "",
    id_rol: 3, // default
  };
}

function fillFormFromUsuario(u) {
  form.id_usuario = u?.id_usuario ?? null;
  form.usuario = u?.usuario ?? "";
  form.nombre = u?.nombre ?? "";
  form.apellido = u?.apellido ?? "";
  form.email = u?.email ?? "";
  form.celular = u?.celular ?? "";
  form.id_rol = u?.id_rol ?? 1;
}

function clearErrors() {
  errors.usuario = "";
  errors.password = "";
  errors.password_repeat = "";
  errors.nombre = "";
  errors.apellido = "";
  errors.email = "";
  errors.id_rol = "";
  saveError.value = "";
}

function validate() {
  clearErrors();
  let ok = true;
  if (!minLength(form.usuario, 5)) {
    errors.usuario = "El usuario es obligatorio.";
    ok = false;
  }

  if (!form.id_usuario) {
    if (!minLength(form.password, 8)) {
      //TODO:: Hacer que la contraseña sea mas complicada (Mayuscula y un simbolo?)
      errors.password = "La contraseña debe tener al menos 8 caracteres.";
      ok = false;
    } else if (form.password != form.password_repeat) {
      //TODO:: Hacer que la contraseña sea mas complicada (Mayuscula y un simbolo?)
      errors.password_repeat = "Las contraseñas no coinciden";
      ok = false;
    }
  }

  if (!form.nombre?.trim()) {
    errors.nombre = "El nombre es obligatorio.";
    ok = false;
  }
  if (!form.apellido?.trim()) {
    errors.apellido = "El apellido es obligatorio.";
    ok = false;
  }
  if (!form.id_rol) {
    errors.id_rol = "El rol es obligatorio.";
    ok = false;
  }
  if (form.email?.trim()) {
    const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim());
    if (!emailOk) {
      errors.email = "El email no tiene un formato válido.";
      ok = false;
    }
  }

  return ok;
}

function getRolDesc(idRol) {
  const r = roles.value.find((x) => x.id_rol === idRol);
  return r ? r.descripcion : "";
}

async function fetchUsuarios() {
  loading.value = true;

  try {
    controller?.abort?.();
  } catch {}
  controller =
    typeof AbortController !== "undefined" ? new AbortController() : null;

  try {
    const data = await apiGetUsuarios({}, { signal: controller?.signal });
    const lista = Array.isArray(data)
      ? data
      : data?.results ?? data?.items ?? [];
    usuarios.value = lista.map((x, i) => ({
      id_usuario: x.id_usuario ?? i,
      usuario: x.usuario ?? "",
      nombre: x.nombre ?? "",
      apellido: x.apellido ?? "",
      email: x.email ?? "",
      celular: x.celular ?? "",
      id_rol: x.id_rol ?? null,
      rol_descripcion: getRolDesc(x.id_rol) ?? "",
      baja_fecha: formatFecha(x.baja_fecha) ?? null,
      ultimo_login: formatFecha(x.ultimo_login) ?? "",
    }));
  } catch (e) {
    console.error(e);
    mensajeError.value =
      "No se pudieron cargar los usuarios. Intente nuevamente por favor.";
    duracionMensajeError.value = 0;
    mostrarMensajeError.value = true;
  } finally {
    loading.value = false;
  }
}

async function fetchRoles() {
  try {
    // Si no tenés endpoint, hardcodeá acá:
    // roles.value = [{ id_rol: 1, descripcion: "Admin" }, { id_rol: 2, descripcion: "Operador" }];
    const data = await apiGetRoles({}, { signal: controller?.signal });
    const lista = Array.isArray(data)
      ? data
      : data?.results ?? data?.items ?? [];

    roles.value = lista.map((r, i) => ({
      id_rol: r.id_rol ?? r.id ?? i + 1,
      descripcion: r.descripcion ?? r.nombre ?? "",
    }));

    // Asegura default si vino vacío
    if (!roles.value.length)
      roles.value = [{ id_rol: 1, descripcion: "Sin rol" }];
  } catch (err) {
    console.error("Error cargando roles", err);
    // fallback
    roles.value = [{ id_rol: 1, descripcion: "Sin rol" }];
  }
}

function onAdd() {
  Object.assign(form, resetForm());
  // si hay roles, seteo un default razonable
  if (roles.value.length) form.id_rol = roles.value[0].id_rol;
  clearErrors();
  modalOpen.value = true;
}

function onEdit(u) {
  fillFormFromUsuario(u);
  clearErrors();
  modalOpen.value = true;
}

function onCancel() {
  modalOpen.value = false;
  mostrarMensajeConfirmacion.value = false;
}

async function onSave() {
  if (!validate()) return;

  saving.value = true;
  saveError.value = "";

  try {
    if (form.id_usuario) {
      const payload = {
        usuario: form.usuario.trim(),
        nombre: form.nombre.trim(),
        apellido: form.apellido.trim(),
        email: form.email?.trim() || null,
        celular: form.celular?.trim() || null,
        id_rol: form.id_rol,
      };

      await apiPutUsuario(form.id_usuario, payload, {
        signal: controller?.signal,
      });
    } else {
      const payload = {
        usuario: form.usuario.trim(),
        password: form.password,
        nombre: form.nombre.trim(),
        apellido: form.apellido.trim(),
        email: form.email?.trim() || null,
        celular: form.celular?.trim() || null,
        id_rol: form.id_rol,
      };
      await apiPostUsuario(payload, { signal: controller?.signal });
    }

    modalOpen.value = false;
    await fetchUsuarios();

    mensajeSuccess.value = form.id_usuario
      ? "El usuario fue modificado correctamente"
      : "El usuario se creó correctamente";
    duracionMensajeSuccess.value = 5000;
    mostrarMensajeSuccess.value = true;
    resetForm()
  } catch (e) {
    console.error(e);
    saveError.value =
      "No se pudo guardar el usuario. Intente nuevamente por favor.";
  } finally {
    saving.value = false;
  }
}

function onDelete(u) {
  esDelete.value = true;
  idUsuarioDelete.value = u.id_usuario;
  mostrarMensajeConfirmacion.value = true;
  mensajeConfirmacion.value = "Confirma dar de baja el usuario?";
}

function onRestore(u) {
  esDelete.value = false;
  idUsuarioDelete.value = u.id_usuario;
  mostrarMensajeConfirmacion.value = true;
  mensajeConfirmacion.value = "Confirma recuperar el usuario dado de baja?";
}

async function borrarUsuario() {
  try {
    if (esDelete.value) {
      const resp = await apiDeleteUsuario(idUsuarioDelete.value, {
        signal: controller?.signal,
      });
      mensajeSuccess.value = "El usuario fue dado de baja correctamente";
    } else {
      const resp = await apiPutRecuperarUsuario(idUsuarioDelete.value, {
        signal: controller?.signal,
      });
      mensajeSuccess.value = "El usuario fue recuperado correctamente";
    }

    await fetchUsuarios();

    // Si tu backend devuelve algo especial (ej -1) podés replicar la misma lógica que clientes.
    // Acá lo dejo simple:
    duracionMensajeSuccess.value = 3000;
    mostrarMensajeSuccess.value = true;
  } catch (e) {
  console.error(e);

  const backendMsg =
    e?.response?.data?.detail ||
    e?.response?.data?.message ||
    e?.message ||
    "No se pudo eliminar el usuario. Intente nuevamente por favor.";

  mostrarMensajeError.value = true;
  mensajeError.value = backendMsg;
  duracionMensajeError.value = 0;
/*
    console.error(e);
    mostrarMensajeError.value = true;
    mensajeError.value =
      ;
    duracionMensajeError.value = 0;
    */
  } finally {
    mostrarMensajeConfirmacion.value = false;
  }
}
</script>
